// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1MuTU","addWidgetButton":"Header_addWidgetButton__7j7xI","dashboardTabs":"Header_dashboardTabs__2NmyA","active":"Header_active__1kNyU"};